import { Link } from "react-router-dom";
import { Button as MUIButton } from "@mui/material";
import styles from "./Button.styles";

const Button = ({
  text,
  handleOnClick,
  styling,
  startIcon,
  to,
  component: componentProp,
  sx,
  ...props
}) => {
  const Component = to ? Link : componentProp || undefined;
  const buttonStyles =
    styling === "primary" ? styles.Button_primary : styles.Button_secondary;

  return (
    <MUIButton
      startIcon={startIcon}
      sx={[buttonStyles, ...(Array.isArray(sx) ? sx : [sx])]}
      component={Component}
      to={to}
      onClick={handleOnClick}
      {...props}
    >
      {text}
    </MUIButton>
  );
};

export default Button;
